/* eslint-disable max-lines */
import Swal from "sweetalert2";
import axios from "axios";

function validate_ticket(vm, scannedCode) {
  if (!vm) return;
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/scan_event_ticket_qr_code/`,
    method: "POST",
    headers: {
      Authorization: `Token ${vm.get_auth_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      event_id: vm.current_event_id,
      unique_code: scannedCode,
    }),
    success: (response) => {
      vm.stop_camera_only();
      vm.scan_success = true;
      vm.scan_data = response;
      vm.show_camera = false;
      vm.scan_result_box = true;
    },
    error: (xhr) => {
      vm.stop_camera_only();
      vm.scan_success = false;
      vm.scan_error_message = xhr.responseJSON?.message || "Invalid or used ticket.";
      vm.show_camera = false;
      vm.scan_result_box = true;
    },
  });
};

function validate_rsvp(vm, scannedCode) {
  if (!vm) return;
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/scan_event_rsvp_qr_code/`,
    method: "POST",
    headers: {
      Authorization: `Token ${vm.get_auth_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      event_id: vm.current_event_id,
      unique_code: scannedCode,
    }),
    success: (response) => {
      vm.stop_camera_only();
      vm.scan_success = true;
      vm.scan_data = response;
      vm.show_camera = false;
      vm.scan_result_box = true;
    },
    error: (xhr) => {
      vm.stop_camera_only();
      vm.scan_success = false;
      vm.scan_error_message = xhr.responseJSON?.message || "Invalid or used ticket.";
      vm.show_camera = false;
      vm.scan_result_box = true;
    },
  });
};

function submit_registration(vm) {
  if (!vm?.event) return;
  vm.selected_event = vm.event;
  if (vm.event.is_free) {
    vm.fetchEvents_extras(vm.event.id);
    return;
  }
  vm.process_to_checkout();
};

function show_cancel_rsvp_error(message) {
  Swal.fire({
    title: "Error",
    text: message,
    icon: "error",
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
    toast: true,
  });
}

function handle_cancel_rsvp_success(vm, event_id, user_id, data) {
  if (data.status !== "success") {
    show_cancel_rsvp_error(data.message || "Cancel failed");
    return;
  }
  if (vm.event?.id === event_id && (!user_id || vm.user_details.user_id === user_id)) {
    vm.event.is_rsvped = false;
  }
  Swal.fire({
    icon: "success",
    title: "RSVP Cancelled",
    showConfirmButton: false,
    timer: 2000,
    position: "bottom-end",
    toast: true,
  }).then(() => {
    $("#exampleModal").modal("hide");
  });
}

function build_cancel_rsvp_payload(vm, event_id, user_id) {
  const payload = { event_id };
  if (user_id == null) {
    payload.user_id = vm.user_details.user_id;
  } else if (
    vm.user_details.user_role === "admin"
    || (vm.user_details.user_role === "organization admin" && user_id)
  ) {
    payload.user_id = user_id;
  }
  payload.base_url = `${window.location.origin}${vm.$route.path}`;
  return payload;
}

function cancel_rsvp(vm, event_id, user_id) {
  if (!vm) return;
  const token = vm.get_auth_token();

  if (!Number.isInteger(event_id)) {
    Swal.fire({
      title: "Invalid ID",
      text: "The event ID is not valid.",
      icon: "error",
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
      toast: true
    });
    return;
  }
  const payload = build_cancel_rsvp_payload(vm, event_id, user_id);

  $.ajax({
    type: "POST",
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/cancel_rsvp/`,
    contentType: "application/json",
    data: JSON.stringify(payload),
    headers: {
      Authorization: `Token ${token}`,
    },
    success: (data) => handle_cancel_rsvp_success(vm, event_id, user_id, data),
    error: (xhr) => {
      const response = xhr.responseJSON || {};
      show_cancel_rsvp_error(response.message || "Something went wrong");
    },
  });
};

function view_ticket_attendees(vm, event) {
  const event_id = event?.id;
  if (!vm || !event_id) return;
  vm.is_submitting = true;
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_ticket_instances/`,
    method: "POST",
    headers: {
      Authorization: `Token ${vm.get_auth_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ event_id }),
    success: (data) => {
      vm.event_ticket_attendees = data.instances || [];
      $("#event_user_ticket").modal("show");
    },
    complete: () => {
      vm.is_submitting = false;
    },
  });
};

function open_media_gallery(vm, event) {
  if (!vm) return;
  vm.event_id = event?.id ?? vm.event_id;
  vm.$refs.eventMediaGalleryRef?.open_media_gallery_modal?.(event);
};

function open_document_upload(vm, event) {
  if (!vm) return;
  vm.event_id = event?.id ?? vm.event_id;
  vm.$refs.eventResourceRef?.open_document_modal?.(event);
};

function get_icon_class(vm, item) {
  if (!vm) return undefined;
  return vm.$refs.eventResourceRef?.get_icon_class(item);
};

function get_file_type_label(vm, item) {
  if (!vm) return undefined;
  return vm.$refs.eventResourceRef?.get_file_type_label(item);
};

function get_file_name(vm, item) {
  if (!vm) return undefined;
  return vm.$refs.eventResourceRef?.get_file_name(item);
};

function open_preview(vm, item) {
  if (!vm) return;
  vm.$refs.eventResourceRef?.open_preview(item);
};

function download_document(vm, item) {
  if (!vm) return;
  vm.$refs.eventResourceRef?.download_document(item);
};

function update_parent_event_files(vm, newFiles) {
  if (!vm?.event) return;
  if (!Array.isArray(vm.event.event_files)) {
    vm.event.event_files = [];
  }
  vm.event.event_files.unshift(...newFiles);
};

function handle_parent_file_deletion(vm, deletedFileId) {
  if (!vm?.event?.event_files) return;
  vm.event.event_files = vm.event.event_files.filter((file) => file.id !== deletedFileId);
};

function handle_pin_update(vm, payload) {
  if (!vm?.event?.event_files) return;
  const index = vm.event.event_files.findIndex((file) => file.id === payload.id);
  if (index === -1) return;
  vm.event.event_files.at(index).is_pinned = payload.is_pinned;
};

function fetch_event(vm) {
  if (!vm) return;
  const event_id = vm.$route.params.event_id;
  if (!event_id) {
    vm.error_message = "Missing event id.";
    vm.is_loading = false;
    return;
  }
  vm.is_loading = true;
  vm.error_message = "";
  const user_id = vm.get_user_id();
  const token = vm.get_auth_token();
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event/`,
    contentType: "application/json",
    method: "POST",
    headers: token
      ? {
        Authorization: `Token ${token}`,
      }
      : {},
    data: JSON.stringify({ event_id: Number(event_id), user_id }),
    success: (response) => {
      if (response?.status === "success") {
        vm.event = response.event;
        vm.event_id = response?.event?.id ?? Number(event_id);
        vm.selected_event = response.event;
        const tickets = Array.isArray(response?.event?.event_tickets)
          ? response.event.event_tickets
          : [];
        vm.event_tickets = tickets.map((ticket) => ({
          ...ticket,
          quantitySelected: 0
        }));
      } else {
        vm.error_message = response?.message || "Failed to load event.";
      }
    },
    error: (xhr) => {
      vm.error_message = xhr?.responseJSON?.message || "Failed to load event.";
    },
    complete: () => {
      vm.is_loading = false;
    }
  });
};

function view_attendees(vm) {
  if (!vm?.event?.id) return;
  if (vm.event.is_free) {
    $("#exampleModal").modal("show");
    return;
  }
  vm.view_ticket_attendees(vm.event);
};

async function add_rsvp(vm) {
  if (!vm) return;

  // 🔐 Not logged in
  if (!vm.token_exists) {
    const nextUrl = vm.$router?.currentRoute?.value?.fullPath;

    if (nextUrl) {
      sessionStorage.setItem("next", nextUrl);
      sessionStorage.setItem("selected_event", JSON.stringify(vm.selected_event));
      sessionStorage.setItem("selected_item_id", JSON.stringify(vm.selected_item_id));
      sessionStorage.setItem("business_name", JSON.stringify(vm.business_name));
      sessionStorage.setItem("is_first_time", JSON.stringify(vm.is_first_time));
      sessionStorage.setItem("chapter", JSON.stringify(vm.chapter));
    }

    vm.$router.push("/login");
    return;
  }

  vm.is_submitting = true;

  try {
    const formData = buildFormData(vm);
    const config = {
      headers: { Authorization: `Token ${vm.get_auth_token()}` }
    };
    const { data } = await axios.post(
      `${process.env.VUE_APP_BACKEND_API_URL}/event_management/add_event_rsvp/`,
      formData,
      config
    );

    handleResponse(vm, data, true);
  } catch (error) {
    const message =
      error?.response?.data?.message || "RSVP failed.";
    handleResponse(vm, message, false);
  } finally {
    vm.is_submitting = false;
  }
};

function buildFormData(vm) {
  const formData = new FormData();
  formData.append("event_id", vm.selected_event.id);
  const items = Array.isArray(vm.selected_item_id)
    ? vm.selected_item_id
    : [vm.selected_item_id];

  items.forEach((id) => formData.append("item_id", id));
  formData.append("business_name", vm.business_name || "");
  formData.append("is_first_time", vm.is_first_time ? "True" : "False");
  formData.append("chapter", vm.chapter || "");
  return formData;
};

function handleResponse(vm, payload, isSuccess) {
  let message = "RSVP failed.";
  if (isSuccess && payload?.status === "success") {
    const isWaitlisted =
      payload?.rsvp_data?.rsvp_status?.name === "waitlisted";

    if (isWaitlisted) {
      vm.event.is_waitlisted = true;
    } else {
      vm.event.is_rsvped = true;
    }
    message = "RSVP Successful";
  } else if (!isSuccess) {
    message = payload;
  }
  Swal.fire({
    icon: isSuccess ? "success" : "info",
    title: isSuccess ? message : undefined,
    text: !isSuccess ? message : undefined,
    showConfirmButton: false,
    timer: 2000,
    position: 'bottom-end',
    toast: true
  }).then(() => {
    Swal.close();
    [
      "selected_event",
      "selected_item_id",
      "business_name",
      "is_first_time",
      "chapter",
    ].forEach((key) => sessionStorage.removeItem(key));
    vm.selected_event = {};
    vm.selected_item_id = [];
    vm.business_name = "";
    $("#rsvp_modal").modal("hide");
  });
};

const event_action_helpers = {validate_ticket,validate_rsvp,submit_registration,cancel_rsvp,view_ticket_attendees,open_media_gallery,open_document_upload,get_icon_class,
  get_file_type_label, get_file_name, open_preview, download_document,
  update_parent_event_files, handle_parent_file_deletion, handle_pin_update, fetch_event,
  view_attendees, add_rsvp,
};

export default event_action_helpers;
